<template>
  <div class="d-flex flex-column">
    <div class="grid-header">
      <h1>{{$t("operaciones_rappel_mensual.titulo")}}</h1>
      <div class="toolbar">
      </div>
    </div>

    <DxDataGrid v-bind="getDefaultGridProperties()" :data-source="gridSource" ref="grid" class="dx-card wide-card grid-liquidaciones">
      <DxColumn data-field="CodigoSecuencial" :caption="$t('liquidaciones.grid.id')" format="0000000000"></DxColumn>
      <DxColumn data-field="FechaActivacion" :caption="$t('liquidaciones.grid.fecha_activacion')" data-type="date" format="dd/MM/yyyy"></DxColumn>
      <DxColumn data-field="DocumentoTitular" :caption="$t('liquidaciones.grid.documento_cliente')"></DxColumn>
      <DxColumn data-field="DireccionTitular" :caption="$t('liquidaciones.grid.direccion_cliente')"></DxColumn>
      <DxColumn data-field="IdTipoSuministro" :caption="$t('operaciones.grid.suministro')">
        <DxLookup column-auto-width="true" v-bind="getLookup('rappels_mensuales', 'tipo_suministro')"></DxLookup>
      </DxColumn>
      <DxColumn data-field="Cups" :caption="$t('operaciones.grid.cups')"></DxColumn>
      <DxColumn type="buttons" :caption="$t('liquidaciones.grid.acciones')" :fixed="true" fixed-position="right" :buttons="[
        {
          cssClass: 'btn btn-link text-decoration-none btn-sm',
          icon: 'fa-solid fa-magnifying-glass text-success',
          hint: $t('liquidaciones.grid.ver_detalle'),
          onClick: (e: any) => verDetalle(e)
        }
      ]"/>
      <DxColumnFixing :enabled="true" />
    </DxDataGrid>
  </div>
</template>

<script setup lang="ts">
import { useApi } from "@api/integration";
import {
  DxDataGrid,
  DxColumnFixing,
  DxColumn,
  DxLookup
} from "devextreme-vue/data-grid";
import {
  getDefaultGridProperties,
  getLookup
} from "@helpers/grid-helper";
import { useModalService } from "@services/modal-service";
import type CustomStore from "devextreme/data/custom_store";
import { onMounted, ref } from "vue";
import OperacionesResumen from "@/components/operaciones-energia/OperacionesEnergiaResumen.vue";
import type DevExpress from "devextreme";
import { useIntl } from "@/.shared/services/i18n/i18nservice";
import { OperacionEnergia } from "@/components/nueva-venta/models/OperacionEnergia";
import type { DXLoadOptions } from "@/.shared/.api";

const props = defineProps(["IdRappelMensual"]);
const api = useApi();
const gridSource = ref<CustomStore>();
const grid = ref<DxDataGrid>();
const modal = useModalService();
const intl = useIntl();

onMounted(async () => {

  gridSource.value = api.apiStore({
    key: "IdTramite",
    load: async (p) => {
      const q = p as DXLoadOptions;
      
      if (q.filter != null && q.filter.length >= 0)
        q.filter = [["IdRappelMensual", "=", props.IdRappelMensual], "and", q.filter];
      else
        q.filter = ["IdRappelMensual", "=", props.IdRappelMensual];

      return await api.callStandardApi("getTramitesEnergiaRappelMensualForGrid", { showLoading: false }, q)
    }
  });
  
});

async function verDetalle(data: DevExpress.ui.dxDataGrid.ColumnButtonClickEvent) {
  let title = `${intl.i18n.t("operaciones.detalle.titulo")} ${data.row?.data.CodigoSecuencial.toString().padStart(10, '0')}`;

  var response = await api.callStandardApi("getOperacionEnergiaDetail", {showLoading: true}, data.row?.data.IdOperacion);
  var model = new OperacionEnergia();
  model.createFromOperacionDetail(response);

  await modal.showModal(OperacionesResumen, { data: model }, { title: title });
}

</script>

<style lang="scss" scoped>


.lupa {
  color: var(--text-secondary-default);
}

.detalle {
  color: var(--text-primary-default);
  cursor: pointer;
}
</style>
